import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'social-starter-decision-maker',
		path: '/decision-maker/:token',
		component: loadable(
			async () => import(/* webpackChunkName: "pages/socialStarter-socialStarterDecisionMaker" */ './index'),
			{
				exportName: 'SocialStarterDecisionMaker',
				fallback: Loading,
			},
		),
		frame: {
			header: true,
			footer: false,
		},
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
